// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".v-text-field[data-v-7c9fa20e]{margin-top:0!important;padding-top:0!important}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
